//  ================================================== Cookie dialog box accessible =============================================================

jQuery(document).ready(function ($) {

  // 1. Unified Enter/Space Key functionality
  $(document).on('keydown', '.cst-quick-trigger, .ot-close-icon, .omgCookie, .cst-close-popup', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).click();
    }
  });

  // 2. Real-time ARIA state updater for switches
  $(document).on('change', '.cst-quick-checkbox, .omgCookie-input-switch', function () {
    var isChecked = $(this).prop('checked');
    var inputId = $(this).attr('id');
    $('label[for="' + inputId + '"]').attr('aria-checked', isChecked ? 'true' : 'false');
  });

  // 3. Dynamic Focus Trap and Escape Key Listener
  $(document).on('keydown', function (e) {
    var $wrapper = $('#cookies-wrapper');
    var $popup = $('#cookies-popup');
    var $activeDialog = null;

    if ($popup.length && $popup.is(':visible')) {
      $activeDialog = $popup;
    } else if ($wrapper.length && $wrapper.is(':visible')) {
      $activeDialog = $wrapper;
    }

    if (!$activeDialog) return;

    // --- ESCAPE KEY LOGIC ---
    if (e.key === 'Escape') {
      var $closeBtn = $activeDialog.find('.ot-close-icon, .cst-close-popup');
      if (!$closeBtn.length) {
        $closeBtn = $activeDialog.find('#cookies-dismiss, .decline-btn');
      }
      $closeBtn.click();
      return; 
    }

    // --- INDEX-BASED FOCUS TRAP LOGIC (Tab Key) ---


    if (e.key === 'Tab') {
  var focusSelectors = '.ot-close-icon, .cst-close-popup, .cst-quick-trigger, .omgCookie, a[href], button:not([disabled])';
  var $focusableElements = $activeDialog.find(focusSelectors).filter(':visible');

  if ($focusableElements.length === 0) return;

  var firstElement = $focusableElements[0]; // FIX: grab the first DOM node, not the whole jQuery set
  var lastElement = $focusableElements[$focusableElements.length - 1];
  var currentIndex = $focusableElements.index(document.activeElement);

  if (e.shiftKey) {
    if (currentIndex === 0 || currentIndex === -1) {
      e.preventDefault();
      lastElement.focus();
    }
  } else {
    if (currentIndex === $focusableElements.length - 1 || currentIndex === -1) {
      e.preventDefault();
      firstElement.focus();
      }
    }
    }
  });

  // 4. Setup the MutationObserver for initial focus and attributes
  var bannerObserver = new MutationObserver(function (mutations, observer) {
    var $wrapper = $('#cookies-wrapper');
    var $popup = $('#cookies-popup');

    // --- MAIN BANNER INIT ---
    if ($wrapper.length) {
      if ($wrapper.is(':visible') && !$wrapper.data('focus-handled')) {
        
        var $titleBanner = $wrapper.find('.otCookies-title-banner');
        if ($titleBanner.length) {
          var rawHtml = $titleBanner.html();
          if (rawHtml.match(/<h4/i)) {
            var fixedHtml = rawHtml.replace(/<h4[^>]*>/gi, '<h2>').replace(/<\/h4[^>]*>/gi, '</h2>');
            $titleBanner.html(fixedHtml);
          }
        }

        $wrapper.attr({
          'role': 'dialog',
          'aria-modal': 'true',
          'aria-labelledby': 'cst-banner-title' 
        });

        // Apply switch roles, initial aria-checked state, and descriptive aria-label
        $('.cst-quick-trigger').each(function() {
          var $label = $(this);
          var $input = $('#' + $label.attr('for'));
          
          // Grab the data-name attribute (e.g., "Marketing") or fallback to empty string
          var cookieName = $input.attr('data-name') || '';
          
          $label.attr({
            'tabindex': '0',
            'role': 'switch',
            'aria-checked': $input.prop('checked') ? 'true' : 'false',
            'aria-label': 'Enable ' + cookieName + ' cookies' // Creates: "Enable Marketing cookies"
          });
        });

        $('.ot-close-icon').attr({ 'tabindex': '0', 'aria-label': 'Close cookie dialog', 'role': 'button' });

        var $focusElements1 = $wrapper.find('.ot-close-icon, .cst-quick-trigger, a[href], button:not([disabled])').filter(':visible');
        if ($focusElements1.length) $focusElements1.first().focus();

        $wrapper.data('focus-handled', true);
      } else if ($wrapper.is(':hidden')) {
        $wrapper.data('focus-handled', false); 
      }
    }

    // --- SECONDARY POPUP INIT ---
    if ($popup.length) {
      if ($popup.is(':visible') && !$popup.data('focus-handled')) {
        
        var $popupTitleP = $popup.find('#cookies-title p');
        if ($popupTitleP.length) {
          $popupTitleP.replaceWith($('<h2>', { 
            html: $popupTitleP.html() 
          }));
        }
        
        $popup.attr({
          'role': 'dialog',
          'aria-modal': 'true',
          'aria-labelledby': 'cookies-title'
        });

        // Apply switch roles, initial aria-checked state, and descriptive aria-label
        $('.omgCookie').each(function() {
          var $label = $(this);
          var $input = $('#' + $label.attr('for'));
          
          // Grab the data-name attribute (e.g., "Analytics") or fallback to empty string
          var cookieName = $input.attr('data-name') || '';
          
          $label.attr({
            'tabindex': '0',
            'role': 'switch',
            'aria-checked': $input.prop('checked') ? 'true' : 'false',
            'aria-label': 'Enable ' + cookieName + ' cookies' // Creates: "Enable Analytics cookies"
          });
        });
        
        $('.cst-close-popup').attr({ 'tabindex': '0', 'aria-label': 'Close cookie dialog', 'role': 'button' });

        var $focusElements2 = $popup.find('.cst-close-popup, .omgCookie, a[href], button:not([disabled])').filter(':visible');
        if ($focusElements2.length) $focusElements2.first().focus();

        $popup.data('focus-handled', true);
      } else if ($popup.is(':hidden')) {
        $popup.data('focus-handled', false);
      }
    }
  });

  // 5. Start observing the body for changes
  bannerObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'] 
  });

});

$(document).ready(function() {
    var checkLabelInterval = setInterval(function() {
        var $targetLabel = $('label[for="agree"]');
        
        // If the label is found on the page
        if ($targetLabel.length > 0) {
            $targetLabel.attr('for', 'effectiveAppsAgreeCB');
            
            // Stop checking once we've fixed it
            clearInterval(checkLabelInterval); 
        }
    }, 500); // 500ms delay between checks
});


//  ================================================== Mini cart dialog box accessible =============================================================

$(document).ready(function () {
    const $cartDrawer = $('cart-drawer details');

    // FIX (root cause of the empty-cart bug):
    // Scope to the WHOLE drawer panel (header + items + footer), not just
    // #mini-cart. #mini-cart only holds line items, so when the cart is
    // empty it contains zero focusable elements and the trap below
    // bails out completely, letting Tab escape onto the page.
    // Adjust this selector to whatever wraps your close button,
    // checkout button, and "continue shopping" link.
    const $cartInner = $('.cart-drawer-container');

    const $triggerIcon = $('.cart-drawer-container summary');

    const focusableSelectors = 'a[href]:not(.visually-hidden), button:not([disabled]):not(.visually-hidden), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]), drawer-close-button, add-to-cart, cart-remove-button';

    function getFocusableElements() {
        let els = $cartInner.find(focusableSelectors).toArray();
        return els.filter(function (el) {
            return (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0)
                && window.getComputedStyle(el).visibility !== 'hidden';
        });
    }

    function fixShopifyElements() {
        $cartInner.find('drawer-close-button, add-to-cart, cart-remove-button').each(function () {
            if (!$(this).attr('tabindex')) {
                $(this).attr('tabindex', '0').attr('role', 'button');
            }
        });
    }

    $(document).on('keydown', function (e) {
        if (!$cartDrawer.prop('open')) return;

        fixShopifyElements();

        const focusableEls = getFocusableElements();
        const activeEl = document.activeElement;

        // Handle ESC
        if (e.key === 'Escape' || e.keyCode === 27) {
            if ($(activeEl).closest('.mini-cart__action[open] > summary + *').length > 0) {
                return;
            }

            e.preventDefault();
            $('drawer-close-button').trigger('click');
            setTimeout(() => $triggerIcon.focus(), 300);
            return;
        }

        // Handle TAB
        if (e.key === 'Tab' || e.keyCode === 9) {
            if (focusableEls.length === 0) {
                // Guard: even with $cartInner now covering the full panel,
                // keep this as a safety net instead of silently returning.
                // Trap focus on the panel itself rather than letting Tab
                // leak out to the page behind the drawer.
                e.preventDefault();
                $cartInner.attr('tabindex', '-1').trigger('focus');
                return;
            }

            // FIX: was `focusableEls` (the whole array) — now actually
            // the first DOM element, so first/last comparisons work.
            const firstEl = focusableEls[0];
            const lastEl = focusableEls[focusableEls.length - 1];

            if (e.shiftKey && activeEl === firstEl) {
                e.preventDefault();
                lastEl.focus();
            } else if (!e.shiftKey && activeEl === lastEl) {
                e.preventDefault();
                firstEl.focus();
            }
        }
    });

    // The Safety Net
    $(document).on('focusin', function (e) {
        if ($cartDrawer.prop('open')) {
            // FIX: $cartInner is a jQuery object — .contains() is a native
            // Node method, not a jQuery one. Use the raw DOM element.
            if (!$cartInner[0].contains(e.target)) {
                const focusableEls = getFocusableElements();
                if (focusableEls.length > 0) {
                    // FIX: focus the first element, not the array itself.
                    focusableEls[0].focus();
                } else {
                    $cartInner.attr('tabindex', '-1').trigger('focus');
                }
            }
        }
    });

    // Handle explicit click on the close button to return focus
    $(document).on('click', 'drawer-close-button', function () {
        setTimeout(() => $triggerIcon.focus(), 500);
    });
});



//  ================================================== Giving alt texts =============================================================


jQuery(document).ready(function ($) {
    // Maps a unique, stable fragment of each image's `src` to the alt
    // text that should describe it. We match against the filename
    // rather than the full src, since Shopify appends changing query
    // params (?v=..., &width=...) to the same CDN file.
    const altTextMap = [
        // "Select Your Edge" hero tiles — these images ARE the link to
        // their respective shop pages, so the alt text doubles as the
        // link's accessible name (what a screen reader announces for
        // the whole clickable tile).
        // NOTE: drafted from filename + page context, not a visual
        // review — confirm against the actual photos before shipping.
        { match: 'MyEdge_Ski.webp', alt: "Skier using the Skier's Edge lateral training machine" },
        { match: 'MyEdge_Hockey.webp', alt: 'Hockey player training on the Hockey Edge lateral training machine' },

        // "As featured in" press logos
        { match: 'MyEdge_Featured_In_Powder.webp', alt: 'Powder Magazine logo' },
        { match: 'MyEdge_Featured_In_Ski_Magazine.webp', alt: 'Ski Magazine logo' },
        { match: 'MyEdge_Featured_In_The_New_York_Times.webp', alt: 'The New York Times logo' },
        { match: 'MyEdge_Featured_In_Mens_Health.webp', alt: "Men's Health logo" },
        { match: 'MyEdge_Featured_In_New_England_Ski_Journal.webp', alt: 'New England Ski Journal logo' },
        { match: 'MyEdge_Featured_In_USA_Hockey_magazine.webp', alt: 'USA Hockey Magazine logo' },
        { match: 'MyEdge_Featured_In_New_England_Hockey_Journal.webp', alt: 'New England Hockey Journal logo' },
        { match: 'MyEdge_Featured_In_Mens_Journal.webp', alt: "Men's Journal logo" },
        { match: 'MyEdge_Featured_In_Park_City_Magazine.webp', alt: 'Park City Magazine logo' },
        { match: 'MyEdge_Featured_In_ESPN.webp', alt: 'ESPN logo' },
        { match: 'MyEdge_Featured_In_MSNBC.webp', alt: 'MSNBC logo' },
        { match: 'MyEdge_Featured_In_JOSPT.webp', alt: 'JOSPT logo' },
        { match: 'MyEdge_Featured_In_Womens_Health.webp', alt: "Women's Health logo" },
        { match: 'MyEdge_Featured_In_Ski_Canada.webp', alt: 'Ski Canada Magazine logo' },

        // Footer logo — wrapped in a link back to the homepage, so the
        // alt should communicate the destination (WCAG technique for
        // linked logos), not repeat marketing copy.
        { match: 'MyEdge_footer_logos.png', alt: 'MyEdge home' },

        // /pages/ski — "Pick Your Package" cards. Each image sits inside
        // its own card-link to a product page, separate from the "Shop
        // X" button at the bottom of the card. With alt="" and no other
        // text in that card-link, the link has NO accessible name at
        // all (WCAG 2.4.4 failure) — a screen reader announces nothing
        // for it. Naming the product gives the link a real name.
        { match: 'Skiers_Edge_Bronze_Intro_Image.jpg', alt: "Skier's Edge Bronze Package" },
        { match: 'Skiers_Edge_Silver_Intro_Image.webp', alt: "Skier's Edge Silver Package" },
        { match: 'Skiers_Edge_Gold_Intro_Image.webp', alt: "Skier's Edge Gold Package" },

        // /pages/ski — "Pro vs Elite" comparison cards. Same unnamed-link
        // pattern as the package cards above.
        { match: 'Skiers_Edge_Elite_Comparison_Image.png', alt: "Skier's Edge Elite" },
        { match: 'Skiers_Edge_Pro_Comparison_Image.png', alt: "Skier's Edge Pro" },
    ];

    // Decorative images: the hero video's poster/thumbnail repeats info
    // already conveyed by the adjacent heading + paragraph ("Pushing
    // boundaries in athletic training..."), and the video itself is
    // ambient/background, not informational. Empty alt tells screen
    // readers to skip it instead of reading the same sentence a third time.
    const decorativeMatches = [
        'a364a9d04d2e4efbaab62ecdb9568e33.thumbnail',
    ];

    function applyAltText() {
        altTextMap.forEach(function (entry) {
            $('img[src*="' + entry.match + '"]').each(function () {
                $(this).attr('alt', entry.alt);
            });
        });

        decorativeMatches.forEach(function (match) {
            $('img[src*="' + match + '"]').each(function () {
                $(this).attr('alt', '');
            });
        });
    }

    applyAltText();

    // Shopify can re-render sections (theme editor, AJAX cart/section
    // updates) after initial load — reapply if new matching <img> tags
    // show up later.
    const altObserver = new MutationObserver(function () {
        applyAltText();
    });
    altObserver.observe(document.body, { childList: true, subtree: true });
});



//  ================================================== Search bar accessible =============================================================


jQuery(document).ready(function ($) {
    var $searchModal = $('.search-modal');
    var $lastFocusBeforeModal = null;

    // Remember whatever had focus right before the modal opened, so we
    // can restore it on close — this works regardless of which header
    // button actually triggers the modal, since we never need its selector.
    $(document).on('focusin', function (e) {
        if (!$searchModal.is(':visible')) {
            $lastFocusBeforeModal = $(e.target);
        }
    });

    function getFocusableElements() {
        return $searchModal
            .find('a[href], button, input, select, textarea, [tabindex]')
            .filter(':visible')
            .filter(function () {
                var $el = $(this);
                // Respect the theme's own tabindex="-1" exclusions. The
                // predictive-search result items, the magnifier submit
                // button, and the icon-only Close button are all
                // intentionally out of the Tab sequence — arrow keys
                // drive the result list (combobox pattern) and Escape
                // covers Close — so they stay excluded here too.
                if ($el.attr('tabindex') === '-1') return false;
                if ($el.is('input, select, textarea, button')) {
                    return !$el.prop('disabled');
                }
                return true;
            })
            .toArray();
    }

    function returnFocusAfterClose() {
        if ($lastFocusBeforeModal && $lastFocusBeforeModal.length && $lastFocusBeforeModal.is(':visible')) {
            $lastFocusBeforeModal.focus();
        }
        $lastFocusBeforeModal = null;
    }

    $(document).on('keydown', function (e) {
        if (!$searchModal.is(':visible')) return;

        // ESC — close via the modal's own Close button, then restore focus
        if (e.key === 'Escape' || e.keyCode === 27) {
            e.preventDefault();
            $searchModal.find('button[aria-label="Close"]').trigger('click');
            setTimeout(returnFocusAfterClose, 50);
            return;
        }

        // TAB — trap focus among whatever's actually tabbable inside
        if (e.key === 'Tab' || e.keyCode === 9) {
            var focusableEls = getFocusableElements();
            if (focusableEls.length === 0) {
                e.preventDefault();
                return;
            }

            var firstEl = focusableEls[0];
            var lastEl = focusableEls[focusableEls.length - 1];
            var activeEl = document.activeElement;

            if (e.shiftKey && activeEl === firstEl) {
                e.preventDefault();
                lastEl.focus();
            } else if (!e.shiftKey && activeEl === lastEl) {
                e.preventDefault();
                firstEl.focus();
            }
        }
    });

    // Safety net: if focus somehow lands outside the modal while it's
    // open, pull it back in rather than letting it leak onto the page.
    $(document).on('focusin', function (e) {
        if ($searchModal.is(':visible') && !$searchModal[0].contains(e.target)) {
            var focusableEls = getFocusableElements();
            if (focusableEls.length > 0) {
                focusableEls[0].focus();
            }
        }
    });
});